import React from 'react'
import { AppContext } from '../../App'
import * as Request from '../../utilities/request'

import { Col, Row } from 'react-bootstrap'
import { Loading } from '../ui/Loading/Loading'
import { AddressedWip } from '../../../../back-end/common/billyDashboard'
import DashboardCard from './dashboardCard'
import { TestingStaff } from '../../screens/dashboard/dashboardWrapper'

interface AddressedWipProps {
	firmView: boolean
	testingStaff?: TestingStaff
}

const AddressedWipCard = (props: AddressedWipProps) => {
	const { appState } = React.useContext(AppContext)

	const [addressedWip, setAddressedWip] = React.useState<AddressedWip | null>(null)
	const [errorMsg, setErrorMsg] = React.useState<string | null>(null)

	React.useEffect(() => {
		const getData = async () => {
			const testingStaffXpmID = props.testingStaff ? '/' + props.testingStaff.xpmID : ''
			const addressedWipRes = await Request.get(`billydashboard/addressedwip${testingStaffXpmID}?firm=${props.firmView}`)

			setAddressedWip(addressedWipRes.data.addressedWip)

			if (!addressedWipRes.data.success) {
				setErrorMsg(addressedWipRes.data.message)
			}
		}

		if (appState.authState.isLoggedIn) {
			getData()
		}
	}, [appState.authState, props])

	if (errorMsg) {
		return (
			<DashboardCard background="lavender">
				<div className="center-flex p-3">
					<span className="span-body-2 span-white">{errorMsg}</span>
				</div>
			</DashboardCard>
		)
	}

	if (!addressedWip) {
		return (
			<DashboardCard background="lavender">
				<div className="center-flex">
					<Loading show style={{ color: 'white' }} />
				</div>
			</DashboardCard>
		)
	}

	/* 	const utilDelta = roundToTwo(((addressedWip.addressedPercentCurrent - addressedWip.addressedPercentPrevious) / 1) * 100)
	const incDec = utilDelta >= 0 ? 'increase' : 'decrease'

	const utilDeltaValid = !isNaN(utilDelta) && utilDelta !== Number.NEGATIVE_INFINITY && utilDelta !== Number.POSITIVE_INFINITY */

	return (
		<DashboardCard background="lavender">
			<Row>
				<Col sm="auto" className="d-flex flex-column">
					<span className="span-body-2 span-bold span-white">ADDRESSED WIP</span>
					<div>
						<span className="font-800-40-48 span-white">{addressedWip.addressedPercentCurrent}</span>
						<span className="font-800-24-48 span-white">%</span>
					</div>
				</Col>
				{/* TODO: Don't think this is reasonably calculable without a shit ton of work */}
				{/* <Col className="d-flex flex-column justify-content-between align-items-end">
					<div className="d-flex flex-column align-items-end">
						<span className="span-body-2 span-white">Last Year</span>
						<div>
							<span className="font-700-16-24 span-white">{addressedWip.addressedPercentPrevious}</span>
							<span className="font-700-12-24 span-white">%</span>
						</div>
					</div>
					{utilDeltaValid && (
						<span className="font-800-12-14 span-white">
							{incDec === 'increase' ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
							<span className="pl-1">
								{Math.abs(utilDelta)}% {incDec} on this period last year
							</span>
						</span>
					)}
				</Col> */}
			</Row>
		</DashboardCard>
	)
}

export default AddressedWipCard
